import { accountOf } from './accounts'
import { filedUnderLabel } from './moves'
import type {
  Arrangement,
  DocumentPage,
  SourceDocument,
  StatementView,
} from './types'

// The pages these numbers name, in the order given. A number the document does not have is left
// out: it names a page of an upload that has since been replaced.
export const pagesNumbered = (
  sourceDocument: SourceDocument,
  pages: number[],
): DocumentPage[] =>
  pages.flatMap((page) => {
    const held = sourceDocument.pages[page - 1]
    return held ? [held] : []
  })

export const arrangementLookup = (
  arrangement: Arrangement,
  views: StatementView[],
  sourceDocument: SourceDocument,
) => {
  const viewById = new Map(views.map((held) => [held.statement.id, held]))
  const holderByPage = new Map<number, StatementView>()
  for (const held of views) {
    for (const page of held.pages) holderByPage.set(page, held)
  }
  const viewOf = (statementId: string | null | undefined) =>
    statementId ? viewById.get(statementId) : undefined

  return {
    viewOf,
    holderByPage,
    pageAt: (page: number) => sourceDocument.pages[page - 1] ?? null,
    pagesOf: (pages: number[]) => pagesNumbered(sourceDocument, pages),
    nameOf: (held: StatementView) =>
      filedUnderLabel(arrangement.accounts, held.statement),
    accountOfStatement: (statementId: string) =>
      accountOf(
        arrangement.accounts,
        viewOf(statementId)?.statement.accountId ?? null,
      ),
  }
}

export type ArrangementLookup = ReturnType<typeof arrangementLookup>
